import Events from '../../utils/events';

export default class EventTarget {
  constructor () {
    this._events = {};
  }

  /**
   * Bind an event handler
   *
   * @param {string|array|object} type Event type
   * @param {function} fn Event handler
   */
  on (type, fn) {
    // Bind to multiple events
    if (Array.isArray(type)) {
      for (let i = 0, l = type.length; i < l; i++) {
        this.on(type[i], fn);
      }
    }
    // Bind to a single event
    else {
      // Create the event handler list if it does not exist yet
      if (!this._events[type]) {
        this._events[type] = [];
      }

      // Push the handler on to the list
      this._events[type].push(fn);
    }
  }

  /**
   * Unbind an event handler
   *
   * @param {string|array|object} type Event type
   * @param {function} fn Event handler
   */
  off (type, fn) {
    // Unbind from multiple events
    if (Array.isArray(type)) {
      for (let i = 0, l = type.length; i < l; i++) {
        this.off(type[i], fn);
      }
    }
    // Unbind from a single event
    else {
      if (!this._events[type]) {
        return;
      }

      // Determine the index of the handler in the event list
      const handlers = this._events[type];
      const index = handlers.indexOf(fn);

      // Remove the handler long as it's a member of the handlers list
      if (index > -1) {
        handlers.splice(index, 1);

        if (handlers.length === 0) {
          delete this._events[type];
        }
      }
    }
  }

  /**
   * Bind an event handler that triggers only once
   *
   * @param {string|array|object} type Event type
   * @param {function} fn Event handler
   */
  one (type, fn) {
    Events.once(this, type, fn);
  }

  /**
   * Trigger an event on the target
   *
   * @param {object|string} event The event to fire or an event type string
   *
   * @return {boolean}
   */
  trigger (event) {
    // Create an event object from a string, assuming the string is an event type
    if (typeof event === 'string') {
      event = {
        type: event
      };
    }

    // Build a list of handlers interested in this event
    let handlers = (this._events[event.type] || []);

    // Add any 'all' handlers to the list
    handlers = handlers.concat(this._events.all || []);

    // Get a copy
    handlers = handlers.slice(0);

    // Call each handler on the target
    for (let i = 0, l = handlers.length; i < l; i++) {
      handlers[i].call(this, event);
    }
  }
}
